import { render, staticRenderFns } from "./Tournaments.vue?vue&type=template&id=5be5c9e6&scoped=true"
import script from "./Tournaments.vue?vue&type=script&lang=js"
export * from "./Tournaments.vue?vue&type=script&lang=js"
import style0 from "./Tournaments.vue?vue&type=style&index=0&id=5be5c9e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be5c9e6",
  null
  
)

export default component.exports